import React from "react";
import PropTypes from "prop-types";

import {FormField, SelectFormField} from "../../../../../../utils/FormFields";
import PhysicalPersonLegalAddress from "../LegalAddress";
import PhysicalPersonLegalInfo from "./LegalInfo";
import PhysicalPersonFiscalResidence from "../FiscalReference";
import {getLocalDate} from "../../../../../../utils/dateUtils";

function PhysicalPersonProfile({person, changedPerson}) {
  const showPerson = changedPerson || person;
  return (
    <React.Fragment>
       <FormField label="Type: " value={person.PersonType} name="PersonType" />
      {showPerson.PhysicalPersonGender !== undefined && (
        <SelectFormField
          label="Gender: "
          value={showPerson.PhysicalPersonGender}
          name="PhysicalPersonGender"
          changedColor={changedPerson}
          selectItems={[
            {id: "N", desc: "Not Specified"},
            {id: "M", desc: "Male"},
            {id: "F", desc: "Female"}
          ]}
          getSelectItemId={i => i.id}
          getSelectItemName={i => i.desc}
        />
      )}
      {showPerson.PersonIsMinimal !== undefined && (
        <SelectFormField
          label="Person is minimal: "
          value={showPerson.PersonIsMinimal}
          name="PersonIsMinimal"
          changedColor={changedPerson}
          selectItems={[
            {id: "true", desc: "Yes"},
            {id: "false", desc: "No"},
          ]}
          getSelectItemId={i => i.id}
          getSelectItemName={i => i.desc}
        />
      )}
      {showPerson.PhysicalPersonFirstName !== undefined && (
        <FormField
          label="First Name: "
          value={showPerson.PhysicalPersonFirstName}
          name="PhysicalPersonFirstName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonSecondName !== undefined && (
        <FormField
          label="Second Name: "
          value={showPerson.PhysicalPersonSecondName}
          name="PhysicalPersonSecondName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonFirstLastName !== undefined && (
        <FormField
          label="First Last Name: "
          value={showPerson.PhysicalPersonFirstLastName}
          name="PhysicalPersonFirstLastName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonSecondLastName !== undefined && (
        <FormField
          label="Second Last Name: "
          value={showPerson.PhysicalPersonSecondLastName}
          name="PhysicalPersonSecondLastName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonEmail !== undefined && (
        <FormField
          label="Email: "
          type="email"
          value={showPerson.PhysicalPersonEmail}
          name="PhysicalPersonEmail"
          changedColor={changedPerson}
        />
      )}

      {showPerson.PersonStatus !== undefined && (
      
        <FormField
          label="Status: "
          type="status"
          value={showPerson.PersonStatus}
          name="PersonStatus"
          changedColor={changedPerson}
        />
        
      )}

      {showPerson.PersonPassedAwayDate !== undefined && (
         <FormField
         label="Date of Passed Away: "
         value={getLocalDate(showPerson.PersonPassedAwayDate)}
         name="PersonPassedAwayDate"
         changedColor={changedPerson}
       />
      )}
      
      {showPerson.PhysicalPersonDateOfBirth !== undefined && (
        <FormField
          label="Date of Birth: "
          value={getLocalDate(showPerson.PhysicalPersonDateOfBirth)}
          name="PhysicalPersonDateOfBirth"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonCountryOfBirthName !== undefined && (
        <FormField
          label="Country of Brith: "
          value={showPerson.PhysicalPersonCountryOfBirthName}
          name="PhysicalPersonCountryOfBirthName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonCityOfBirthName !== undefined && (
        <FormField
          label="City of Brith: "
          value={showPerson.PhysicalPersonCityOfBirthName}
          name="PhysicalPersonCityOfBirthName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonCivilStatus && (
        <FormField
          label="Civil Status: "
          value={showPerson.PhysicalPersonCivilStatus}
          name="PhysicalPersonCivilStatus"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseFirstName !== undefined && (
        <FormField
          label="Spouse First Name: "
          value={showPerson.SpouseFirstName}
          name="SpouseFirstName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseSecondName !== undefined && (
        <FormField
          label="Spouse Second Name: "
          value={showPerson.SpouseSecondName}
          name="SpouseSecondName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseFirstLastName !== undefined && (
        <FormField
          label="Spouse First Last Name: "
          value={showPerson.SpouseFirstLastName}
          name="SpouseFirstLastName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseSecondLastName !== undefined && (
        <FormField
          label="Spouse Second Last Name: "
          value={showPerson.SpouseSecondLastName}
          name="SpouseSecondLastName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseDocumentTypeName !== undefined && (
        <FormField
          label="Spouse Document Type: "
          value={showPerson.SpouseDocumentTypeName}
          name="SpouseDocumentTypeId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseDocumentNumber !== undefined && (
        <FormField
          label="Spouse Document Number: "
          value={showPerson.SpouseDocumentNumber}
          name="SpouseDocumentNumber"
          changedColor={changedPerson}
        />
      )}
      {showPerson.SpouseDocumentCountryOfIssueName !== undefined && (
        <FormField
          label="Spouse Document Country of Issue: "
          value={showPerson.SpouseDocumentCountryOfIssueName}
          name="SpouseDocumentCountryOfIsseName"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonPositionIndustry !== undefined && (
        <FormField
          label="Position Industry: "
          value={showPerson.PhysicalPersonPositionIndustry}
          name="PhysicalPersonPositionIndustry"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWorkingIndustry !== undefined && (
        <FormField
          label="Working Industry: "
          value={showPerson.PhysicalPersonWorkingIndustry}
          name="PhysicalPersonWorkingIndustry"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonRelatedFrom !== undefined && (
        <FormField
          label="Related From: "
          value={showPerson.PersonRelatedFrom}
          name="PersonRelatedFrom"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonObservations !== undefined && (
        <FormField
          label="Observations: "
          value={showPerson.PersonObservations}
          name="PersonObservations"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonCurrencyType !== undefined && (
        <FormField
          label="Currency Type: "
          value={showPerson.PersonCurrencyType}
          name="PersonCurrencyType"
          changedColor={changedPerson}
        />
      )}
      <PhysicalPersonLegalInfo person={person} changedPerson={changedPerson} />
      {showPerson.PersonFiscalResidence!== undefined &&person&&person.PersonFiscalResidence!=null&&
      changedPerson&&changedPerson.PersonFiscalResidence!=null&&
      changedPerson.PersonFiscalResidence.length>0&& (
      <PhysicalPersonFiscalResidence
        person={person}
        changedPerson={changedPerson}
      />
      )}
    </React.Fragment>
  );
}

PhysicalPersonProfile.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object
};

PhysicalPersonProfile.defaultProps = {
  changedPerson: undefined
};

export default PhysicalPersonProfile;
